package br.com.texeratx.boardgametimeapp.core.spotify.api

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SpotifyDevicesResponse(
    val devices: List<SpotifyDeviceDto> = emptyList()
)

@Serializable
data class SpotifyDeviceDto(
    val id: String? = null,
    val name: String = "",
    val type: String = "",
    @SerialName("is_active")
    val isActive: Boolean = false,
    @SerialName("is_restricted")
    val isRestricted: Boolean = false,
    @SerialName("volume_percent")
    val volumePercent: Int? = null
)
